import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { FormGroupState } from 'ngrx-forms';
import { Observable } from 'rxjs/index';
import { AdminUserDevicesFormValue, AdminUserDevicesState } from './user-devices.state';

const formStateSelector = (state: AdminUserDevicesState) => state.userDevicesForm.formState;
const formStateValueSelector = (state: AdminUserDevicesState) => {
    if (state.userDevicesForm.formState === undefined) {
        console.log('formStateValueSelector called too early');

        return undefined;
    }

    return state.userDevicesForm.formState.value;
};

const loadingSelector = (state: AdminUserDevicesState) => state.userDevicesForm.loading;

const isFormDirtySelector = (state: AdminUserDevicesState) => state.userDevicesForm.formState.isDirty;

@Injectable()
export class UserDevicesSelectors {
    constructor(private store: Store<any>) {
    }

    selectFormState(): Observable<FormGroupState<AdminUserDevicesFormValue>> {
        return this.store.pipe(select(formStateSelector));
    }

    selectFormStateValue(): Observable<AdminUserDevicesFormValue> {
        return this.store.pipe(select(formStateValueSelector));
    }

    selectLoadingStatus(): Observable<boolean> {
        return this.store.pipe(select(loadingSelector));
    }

    selectIsFormDirty(): Observable<boolean> {
        return this.store.pipe(select(isFormDirtySelector));
    }

}
